import { frontendURL } from '../../../helper/URLHelper';
const SmsConfiguration = () => import('./Index.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/sms'),
    name: 'sms_configuration',
    meta: {
      permissions: ['administrator', 'sms_manage'],
      module: 'sms',
    },
    component: SmsConfiguration,
  },
];
